import { mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { css } from 'styled-components'

export const SpotAsset = styled(Asset)`
  max-height: 715px;
  margin: auto;
  ${mixins.margin.bottom(25)};
`
export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  ${mixins.padding.bottom(25)};
  margin: auto;
`
export const ContentRight = styled.div`
  display: flex;
  flex-wrap: wrap;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
  ${mixins.padding.bottom(25)};
  width: 100%;

  & > a {
    ${mixins.margin.bottom(25)}
  }
`
export const Caption = styled.h5`
  width: 100%;
  ${mixins.typography.subtitleMedium};
  ${mixins.margin(0)};
`
export const Headline = styled.h1`
  width: 100%;
  ${mixins.typography.headlineLarge};
  ${mixins.margin.top(20)};
  ${mixins.margin.bottom(25)};
`
export const Description = styled.div`
  width: 100%;
  ${mixins.margin(25, 0)};

  & p {
    font-weight: 400;
    color: ${mixins.colors.grayDark};
    ${mixins.margin(0)};
  }
`
export type LearnMoreButtonWrapperProps = {
  isUnderImage?: boolean
}
export const LearnMoreButtonWrapper = styled.div<LearnMoreButtonWrapperProps>`
  width: 100%;
  ${({ isUnderImage }) =>
    isUnderImage &&
    css`
      margin: 30px auto;
      text-align: center;
    `}
`
